import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Backend from "./views/Backend.vue";
import Redirect from "./views/Redirect.vue";
import Login from "./views/account/Login.vue";
import None404 from "./views/None404.vue";


//消除vue-router NavigationDuplicated报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router);

var router = new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      redirect: () => {
        return "/home";
      }
    },
    {
      path: "/redirect",
      name: "redirect",
      component: Redirect
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/login_tel",
      name: "login_tel",
      component: Login
    },
    {
      path: "/register",
      name: "register",
      component: Login
    },
    {
      path: "/forget_password",
      name: "forget_password",
      component: Login
    },
    {
      name: "home",
      path: "/home",
      component: Home,
      children: [
        {
          path: "/",
          redirect: (to) => {
            return "index";
          }
        },
        {
          name: "index",
          path: "index",
          component: () => import(/* webpackChunkName: "home_index" */ "./views/home_index/HomeIndex.vue").catch(() => window.location.reload()),
        },
        {
          name: "forum",
          path: "forum",
          component: () => import(/* webpackChunkName: "home_forum" */ "./views/home_forum/HomeForum.vue").catch(() => window.location.reload()),
        },
        {
          name: "forum_detail",
          path: "forum/:id",
          component: () => import(/* webpackChunkName: "home_forum" */ "./views/home_forum/HomeForum.vue").catch(() => window.location.reload()),
        },
        {
          path: "help",
          component: () => import(/* webpackChunkName: "home_help" */ "./views/home_help/HomeHelp.vue").catch(() => window.location.reload()),
        },
        {
          path: "market_price",
          component: () => import(/* webpackChunkName: "home_market_price" */ "./views/home_market_price/HomeMarketPrice.vue").catch(() => window.location.reload()),
        },
        {
          path: "article",
          component: () => import(/* webpackChunkName: "home_article" */ "./views/home_article/HomeArticle.vue").catch(() => window.location.reload()),
        },
        {
          path: "article/detail/:id",
          component: () => import(/* webpackChunkName: "home_article_detail" */ "./views/home_article/HomeArticleDetail.vue").catch(() => window.location.reload()),
        },
        {
          name: "home_quotation",
          path: "quotation",
          component: () => import(/* webpackChunkName: "home_quotation" */ "./views/home_quotation/HomeQuotation.vue").catch(() => window.location.reload())
        },
        {
          name: "home_quotation_detail",
          path: "quotation/:code",
          component: () => import(/* webpackChunkName: "home_quotation_detail" */ "./views/home_quotation/HomeQuotationDetail.vue").catch(() => window.location.reload()),
        },
        {
          name: "home_raise",
          path: "raise",
          component: () => import(/* webpackChunkName: "home_raise" */ "./views/home_raise/HomeRaise.vue").catch(() => window.location.reload())
        },
        {
          path: "raise/:code",
          component: () => import(/* webpackChunkName: "home_raise_detail" */ "./views/home_raise/HomeRaiseDetail.vue").catch(() => window.location.reload())
        },
        {
          name: "home_purchase_material",
          path: "purchase_material",
          component: () => import(/* webpackChunkName: "home_purchase" */ "./views/home_purchase/HomePurchase.vue").catch(() => window.location.reload())
        },
        {
          name: "home_purchase_piece",
          path: "purchase_piece",
          component: () => import(/* webpackChunkName: "home_purchase" */ "./views/home_purchase/HomePurchase.vue").catch(() => window.location.reload())
        },
        {
          name: "home_purchase_forging",
          path: "purchase_forging",
          component: () => import(/* webpackChunkName: "home_purchase" */ "./views/home_purchase/HomePurchase.vue").catch(() => window.location.reload())
        },
        {
          name: "home_purchase_machining",
          path: "purchase_machining",
          component: () => import(/* webpackChunkName: "home_purchase" */ "./views/home_purchase/HomePurchase.vue").catch(() => window.location.reload())
        },
        {
          name: "home_purchase_material_detail",
          path: "purchase_material/:code",
          component: () => import(/* webpackChunkName: "home_purchase_detail" */ "./views/home_purchase/HomePurchaseDetail.vue").catch(() => window.location.reload()),
        },
        {
          name: "home_purchase_piece_detail",
          path: "purchase_piece/:code",
          component: () => import(/* webpackChunkName: "home_purchase_detail" */ "./views/home_purchase/HomePurchaseDetail.vue").catch(() => window.location.reload()),
        },
        {
          name: "home_purchase_forging_detail",
          path: "purchase_forging/:code",
          component: () => import(/* webpackChunkName: "home_purchase_detail" */ "./views/home_purchase/HomePurchaseDetail.vue").catch(() => window.location.reload()),
        },
        {
          name: "home_purchase_machining_detail",
          path: "purchase_machining/:code",
          component: () => import(/* webpackChunkName: "home_purchase_detail" */ "./views/home_purchase/HomePurchaseDetail.vue").catch(() => window.location.reload()),
        },
        {
          path: "good_business",
          component: () => import(/* webpackChunkName: "home_good_business" */ "./views/home_good_business/HomeGoodBusiness.vue").catch(() => window.location.reload()),
        },
        {
          path: "inspect_business",
          component: () => import(/* webpackChunkName: "home_inspect_business" */ "./views/home_inspect_business/HomeInspectBusiness.vue").catch(() => window.location.reload()),
        },
        {
          path: "site_map",
          name: "site_map",
          component: () => import(/* webpackChunkName: "site_map" */"./views/SiteMap.vue").catch(() => window.location.reload()),
        },
      ]
    },

    {
      name: "backend",
      path: "/backend",
      component: Backend,
      //FIXME 精准匹配到该路由才会触发redirect
      redirect: (to) => {
        return "/backend/dashboard"
      },
      children: [
        {
          path: "dashboard",
          component: () => import(/* webpackChunkName: "dashboard" */ "./views/dashboard/Dashboard.vue").catch(() => window.location.reload()),
        },
        {
          path: "collection",
          component: () => import(/* webpackChunkName: "collection" */ "./views/collection/Collection.vue").catch(() => window.location.reload()),
        },
        {
          path: "staff",
          component: () => import(/* webpackChunkName: "staff" */ "./views/staff/Staff.vue").catch(() => window.location.reload()),
        },
        {
          path: "customer",
          component: () => import(/* webpackChunkName: "customer" */ "./views/customer/Customer.vue").catch(() => window.location.reload()),
        },
        {
          name: "buyer_purchase_material",
          path: "buyer_purchase_material",
          component: () => import(/* webpackChunkName: "buyer_purchase" */"./views/buyer_purchase/BuyerPurchase.vue").catch(() => window.location.reload()),
        },
        {
          name: "buyer_purchase_piece",
          path: "buyer_purchase_piece",
          component: () => import(/* webpackChunkName: "buyer_purchase" */"./views/buyer_purchase/BuyerPurchase.vue").catch(() => window.location.reload()),
        },
        {
          name: "buyer_purchase_forging",
          path: "buyer_purchase_forging",
          component: () => import(/* webpackChunkName: "buyer_purchase" */"./views/buyer_purchase/BuyerPurchase.vue").catch(() => window.location.reload()),
        },
        {
          name: "buyer_purchase_machining",
          path: "buyer_purchase_machining",
          component: () => import(/* webpackChunkName: "buyer_purchase" */"./views/buyer_purchase/BuyerPurchase.vue").catch(() => window.location.reload()),
        },
        {
          name: "seller_quotation",
          path: "seller_quotation",
          component: () => import(/* webpackChunkName: "seller_quotation" */"./views/seller_quotation/SellerQuotation.vue").catch(() => window.location.reload()),
        },
      ],
    },

    {
      name: "admin",
      path: "/admin",
      component: Backend,
      children: [
        {
          path: "/",
          redirect: (to) => {
            return "dashboard";
          }
        },
        {
          path: "dashboard",
          component: () => import(/* webpackChunkName: "admin_dashboard" */ "./views/admin_dashboard/AdminDashboard.vue").catch(() => window.location.reload()),
        },
        {
          path: "tenant",
          component: () => import(/* webpackChunkName: "admin_tenant" */ "./views/admin_tenant/Tenant.vue").catch(() => window.location.reload()),
        },
        {
          path: "user",
          component: () => import(/* webpackChunkName: "admin_user" */ "./views/admin_user/User.vue").catch(() => window.location.reload()),
        },
        {
          path: "backend_user",
          component: () => import(/* webpackChunkName: "backend_user" */ "./views/admin_user/BackendUser.vue").catch(() => window.location.reload()),
        },
        {
          path: "app_edition",
          component: () => import(/* webpackChunkName: "admin_app_edition" */ "./views/admin_app_edition/AppEdition").catch(() => window.location.reload()),
        },
        {
          path: "quotation",
          component: () => import(/* webpackChunkName: "admin_quotation" */ "./views/admin_quotation/AdminQuotation.vue").catch(() => window.location.reload()),
        },
        {
          name: "admin_purchase_material",
          path: "purchase_material",
          component: () => import(/* webpackChunkName: "admin_purchase" */ "./views/admin_purchase/AdminPurchase.vue").catch(() => window.location.reload()),
        },
        {
          name: "admin_purchase_piece",
          path: "purchase_piece",
          component: () => import(/* webpackChunkName: "admin_purchase" */ "./views/admin_purchase/AdminPurchase.vue").catch(() => window.location.reload()),
        },
        {
          name: "admin_purchase_forging",
          path: "purchase_forging",
          component: () => import(/* webpackChunkName: "admin_purchase" */ "./views/admin_purchase/AdminPurchase.vue").catch(() => window.location.reload()),
        },
        {
          name: "admin_purchase_machining",
          path: "purchase_machining",
          component: () => import(/* webpackChunkName: "admin_purchase" */ "./views/admin_purchase/AdminPurchase.vue").catch(() => window.location.reload()),
        },
        {
          path: "raise",
          component: () => import(/* webpackChunkName: "admin_raise" */ "./views/admin_raise/AdminRaise.vue").catch(() => window.location.reload()),
        },
        {
          path: "article",
          component: () => import(/* webpackChunkName: "admin_article" */ "./views/admin_article/AdminArticle.vue").catch(() => window.location.reload()),
        },
        {
          path: "website_config",
          component: () => import(/* webpackChunkName: "website_config" */ "./views/admin_website_config/AdminWebsiteConfig.vue").catch(() => window.location.reload()),
        },
        {
          path: "banner",
          component: () => import(/* webpackChunkName: "banner" */ "./views/admin_banner/AdminBanner.vue").catch(() => window.location.reload()),
        },
        {
          path: "tag",
          component: () => import(/* webpackChunkName: "admin_tag" */ "./views/admin_tag/AdminTag.vue").catch(() => window.location.reload()),
        },
        {
          path: "forum",
          component: () => import(/* webpackChunkName: "admin_forum" */"./views/admin_forum/AdminForum.vue").catch(() => window.location.reload()),
        },
        {
          path: "good_business",
          component: () => import(/* webpackChunkName: "admin_good_business" */"./views/admin_good_business/AdminGoodBusiness.vue").catch(() => window.location.reload()),
        },

        {
          path: "inspect_business",
          component: () => import(/* webpackChunkName: "admin_inspect_business" */"./views/admin_inspect_business/AdminInspectBusiness.vue").catch(() => window.location.reload()),
        },
      ]
    },
    {
      path: "/icp",
      name: "icp",
      component: () => import(/* webpackChunkName: "icp" */"./views/ICP.vue").catch(() => window.location.reload()),
    },
    {
      path: "*",
      name: "none404",
      component: None404,
    },

    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ],
});

export default router;
